import React from "react";

export default function Hero() {
  return (
    <>
      <section className="home" id="home">
        <div className="content">
          <h3>save the planet</h3>
          <p>
            We don’t inherit the earth from our ancestors, we borrow it from our
            children. —Native American proverb
          </p>
          <a href="#" className="btn">
            get started
          </a>
        </div>
      </section>
    </>
  );
}
